var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 26.5,
    height: 26.5,
    rx: 3.75,
    stroke: "#7752FE",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6418 16.519V14.188H15.0648C15.5128 14.188 15.9188 14.097 16.2828 13.915C16.6468 13.733 16.9338 13.474 17.1438 13.138C17.3538 12.788 17.4588 12.368 17.4588 11.878C17.4588 11.402 17.3538 10.989 17.1438 10.639C16.9338 10.289 16.6468 10.023 16.2828 9.841C15.9188 9.659 15.5128 9.568 15.0648 9.568H11.6418V7.237H15.3588C16.2968 7.237 17.1368 7.426 17.8788 7.804C18.6348 8.182 19.2298 8.721 19.6638 9.421C20.0978 10.107 20.3148 10.926 20.3148 11.878C20.3148 12.83 20.0978 13.656 19.6638 14.356C19.2298 15.042 18.6348 15.574 17.8788 15.952C17.1368 16.33 16.2968 16.519 15.3588 16.519H11.6418ZM9.54179 22V7.237H12.3978V22H9.54179Z",
    fill: "#7752FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPings);
export default __webpack_public_path__ + "static/media/pings.230d1782bbe3ba394352dea4cb5e9762.svg";
export { ForwardRef as ReactComponent };